import { cva } from "class-variance-authority";

export { default as Checkbox } from "./Checkbox";
export const sizes = ["sm", "md"];

export const variants = cva(
    [
        "self-start",
        "border border-primary",
        "justify-center",
        "align-self-top",
        "fg-white",
        "rounded-xs",
        "focus-within:ring-brand",
        "disabled:pointer-events-none",
        "disabled:fg-disabled",
        "disabled:bg-disabled",
        "disabled:border-disabled",
    ],
    {
        variants: {
            size: {
                sm: ["h-[16px]", "w-[16px]"],
                md: ["h-[20px]", "w-[20px]"],
            },
        },
        compoundVariants: [
            {
                checked: [true, "indeterminate"],
                class: ["border-none"],
                disabled: [false],
            },
        ],
        defaultVariants: {
            size: "md",
            indeterminate: false,
            disabled: false,
            checked: false,
        },
    }
);
